var _path, _path2, _path3, _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeDislike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 127,
    viewBox: "0 0 223 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 114.747C91.5738 114.747 114.737 91.5813 114.737 63.0051C114.737 34.429 91.5738 11.2635 63 11.2635C34.4262 11.2635 11.2626 34.429 11.2626 63.0051C11.2626 91.5813 34.4262 114.747 63 114.747ZM63 126.01C97.794 126.01 126 97.8019 126 63.0051C126 28.2084 97.794 0 63 0C28.2061 0 0 28.2084 0 63.0051C0 76.6273 4.32271 89.2398 11.6711 99.5454L0.626148 127L23.9651 112.462C34.6977 120.946 48.2575 126.01 63 126.01Z",
    fill: "#70D9B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 114.747C131.426 114.747 108.263 91.5813 108.263 63.0051C108.263 34.429 131.426 11.2635 160 11.2635C188.574 11.2635 211.737 34.429 211.737 63.0051C211.737 91.5813 188.574 114.747 160 114.747ZM160 126.01C125.206 126.01 97 97.8019 97 63.0051C97 28.2084 125.206 0 160 0C194.794 0 223 28.2084 223 63.0051C223 76.6273 218.677 89.2398 211.329 99.5454L222.374 127L199.035 112.462C188.302 120.946 174.742 126.01 160 126.01Z",
    fill: "#FA6C51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.833 93.456C106.751 96.9237 108.987 100.191 111.5 103.22C114.014 100.191 116.249 96.9237 118.167 93.456C115.413 89.6791 113.159 85.5152 111.5 81.0611C109.842 85.5152 107.587 89.6791 104.833 93.456ZM111.5 44.9492C109.842 40.4951 107.587 36.3311 104.833 32.5542C106.751 29.0865 108.987 25.8189 111.5 22.7904C114.014 25.8189 116.249 29.0865 118.167 32.5542C115.413 36.3311 113.159 40.4951 111.5 44.9492Z",
    fill: "#376456"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1305_41660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.75 33H57V41.25L48.75 60.5V82.5C48.75 83.9587 49.3295 85.3576 50.3609 86.3891C51.3924 87.4205 52.7913 88 54.25 88H76.25C79.275 88 82.6025 85.69 83.675 82.83L90 66V60.5C90 59.0413 89.4205 57.6424 88.3891 56.6109C87.3576 55.5795 85.9587 55 84.5 55H65.25V38.5C65.25 37.0413 64.6705 35.6424 63.6391 34.6109C62.6076 33.5795 61.2087 33 59.75 33ZM43.25 60.5H35V88H43.25V60.5Z",
    fill: "#FA6C51"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1305_41660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.75 33H57V41.25L48.75 60.5V82.5C48.75 83.9587 49.3295 85.3576 50.3609 86.3891C51.3924 87.4205 52.7913 88 54.25 88H76.25C79.275 88 82.6025 85.69 83.675 82.83L90 66V60.5C90 59.0413 89.4205 57.6424 88.3891 56.6109C87.3576 55.5795 85.9587 55 84.5 55H65.25V38.5C65.25 37.0413 64.6705 35.6424 63.6391 34.6109C62.6076 33.5795 61.2087 33 59.75 33ZM43.25 60.5H35V88H43.25V60.5Z",
    fill: "#70D9B8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1305_41660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.25 96H170V87.75L178.25 68.5V46.5C178.25 45.0413 177.671 43.6424 176.639 42.6109C175.608 41.5795 174.209 41 172.75 41H150.75C147.725 41 144.398 43.31 143.325 46.17L137 63V68.5C137 69.9587 137.579 71.3576 138.611 72.3891C139.642 73.4205 141.041 74 142.5 74H161.75V90.5C161.75 91.9587 162.329 93.3576 163.361 94.3891C164.392 95.4205 165.791 96 167.25 96ZM183.75 68.5H192V41H183.75V68.5Z",
    fill: "#FA6C51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1305_41660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white",
    transform: "matrix(-1 0 0 1 90 33)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1305_41660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white",
    transform: "matrix(-1 0 0 1 90 33)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1305_41660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white",
    transform: "matrix(1 0 0 -1 137 96)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeDislike);
export default __webpack_public_path__ + "static/media/like-dislike.5bc64eb031691fec726577bb5289692f.svg";
export { ForwardRef as ReactComponent };